import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import configureStore from './store/store'
import { matchRoutes, renderRoutes } from 'react-router-config'
import { Provider } from 'react-redux'

import routes from './client/routes'
global.__SERVER__ = false

const store = configureStore(
	window.__INITIAL_STATE__,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

ReactDOM.render(
	<BrowserRouter>
		<Provider store={ store }>
			{/* <DataLoader /> */ }
			{ renderRoutes(routes) }
		</Provider>
	</BrowserRouter>
	,
	document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js